import React from 'react'
import {TableBody} from 'grommet'

function DataGridBody({children, ...rest}) {
  return <TableBody>{children}</TableBody>
}
export default DataGridBody
